export default {
  getRedirectPath(menus) {
    const menu = menus[0]
    let redirectPath = '/'
    if (menu.children && menu.children.length > 0) {
      redirectPath = this.getRedirectPath(menu.children)
    } else {
      redirectPath = menu.path
    }
    return redirectPath
  }
}
